"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrequencyService = void 0;
const api_1 = require("./api");
const PATH_V1 = '/frequency/api/v1';
class FrequencyService {
    static async getGlobalFrequency(key) {
        const url = `${PATH_V1}/cap/global/${key}`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
}
exports.FrequencyService = FrequencyService;
//# sourceMappingURL=frequency-service.js.map